export default __webpack_public_path__ + "static/groups-project-settings-dark-mode-cc44999a0550f1ed902d2fac0a6c00a4.png";